import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PersonIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="person" ref={ref} {...props}>
      <path d="M12.05,11.9a4.58,4.58,0,1,1,4.58-4.58A4.58,4.58,0,0,1,12.05,11.9Zm0-7.65a3.08,3.08,0,1,0,3.08,3.07A3.08,3.08,0,0,0,12.05,4.25Zm8.8,16.25a5.72,5.72,0,0,0-5.72-5.71H8.88A5.72,5.72,0,0,0,3.16,20.5a.75.75,0,0,0,1.5,0,4.22,4.22,0,0,1,4.22-4.21h6.25a4.22,4.22,0,0,1,4.22,4.21.75.75,0,0,0,1.5,0Z" />
    </Icon>
  ),
) as IconWithRender;

PersonIcon.displayName = 'PersonIcon';
PersonIcon.renderIcon = (props) => <PersonIcon {...props} />;
export default PersonIcon;
